import { connect } from "react-redux";
import Container from "./container";
import { actionCreators as userActions } from "redux/user";

const mapStateToProps = (state, ownProps) => {
  const {
    user: { auth = {} }
  } = state;
  return {
    auth
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    searchUser: (query) => {
      return dispatch(userActions.searchUser(query));
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Container);
